import { ResourceProps } from '@/libs/contentful/types';
import { RelatedArticleProps, RelatedArticleFlexibleProps } from './types';
import { getRichTextValue } from '@/utils/formatters';
import { extractSlugFromUrl } from '@/libs/contentful/utils';
import { isInternalLink } from '@/utils/linkHelpers';

export const resourceToArticleShim = (
  item: ResourceProps | RelatedArticleProps | RelatedArticleFlexibleProps,
  taxonomyLabel?: string,
  taxonomyUri?: string,
): RelatedArticleProps => {
  const getCategory = (defaultCategory?: { label: string; url?: string }) => {
    if (taxonomyLabel) {
      return { label: taxonomyLabel, url: taxonomyUri };
    }
    return defaultCategory;
  };

  if (item.__typename === 'Resource') {
    const defaultCategory = item?.resourceLabelRte ? { label: getRichTextValue(item.resourceLabelRte) } : undefined;
    const isExternal = item.url && !item.resourcePage && !isInternalLink(item.url);
    return {
      __typename: 'RelatedArticle',
      articleTitle: item.resourceCopy,
      articleImage: item.resourceIcon,
      slug: isExternal ? '' : item.resourcePage?.slug || extractSlugFromUrl(item.url),
      href: isExternal ? item.url : undefined,
      category: getCategory(defaultCategory),
      sys: item?.sys || { id: '' },
    };
  }

  if (item.__typename === 'PageBlogPostFlexible') {
    const defaultCategory = item.category ? { label: item.category.label, url: item.category.url } : undefined;
    return {
      __typename: 'RelatedArticle',
      articleTitle: item.articleTitle?.headline,
      articleImage: item.articleImage?.desktopMedia,
      slug: item.slug,
      category: getCategory(defaultCategory),
      categories: item.categories,
      sys: item.sys,
      publishDate: item.publishDate,
    };
  }

  const relatedArticle = item as RelatedArticleProps;
  return {
    ...relatedArticle,
    category: getCategory(relatedArticle.category),
  };
};
